import "./carregando.css";

/** Um cartão da grade de Produtos, vazio, no mesmo formato do de verdade. */
function Cartao() {
  return (
    <div className="bg-card rounded-xl border overflow-hidden">
      <span className="cc-skel aspect-square w-full rounded-none" />
      <div className="p-3 space-y-2">
        <span className="cc-skel h-3.5 w-4/5" />
        <span className="cc-skel h-3 w-1/3" />
        <div className="flex items-center justify-between pt-2 border-t border-dashed border-border/60">
          <span className="cc-skel h-4 w-16" />
          <span className="cc-skel h-3 w-10" />
        </div>
      </div>
    </div>
  );
}

function Linha({ primeira }) {
  return (
    <div className={`flex items-center px-3 sm:px-4 py-2.5 gap-2.5 sm:gap-3 ${primeira ? "" : "border-t"}`}>
      <span className="cc-skel h-6 w-10 sm:h-5 sm:w-8 rounded-full shrink-0" />
      <span className="cc-skel w-10 h-10 rounded-lg shrink-0" />
      <span className="flex-1 min-w-0 space-y-1.5">
        <span className="cc-skel h-3.5 w-3/5" />
        <span className="cc-skel h-2.5 w-1/4" />
      </span>
      <span className="cc-skel h-3.5 w-16 shrink-0" />
    </div>
  );
}

/**
 * Cartões fantasma de Cardápio → Produtos enquanto a lista chega, no lugar da
 * bolinha girando (dono, 24/10/2026: "sensação de progresso"). Segue o modo
 * de exibição escolhido: grade ou lista.
 */
export default function ProdutosCarregando({ modo = "grid", n = 10 }) {
  if (modo === "list") {
    return (
      <div className="bg-card rounded-xl border overflow-hidden" aria-label="Carregando produtos" aria-busy="true" data-e2e="produtos-carregando">
        {Array.from({ length: n }, (_, i) => <Linha key={i} primeira={i === 0} />)}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4"
      aria-label="Carregando produtos" aria-busy="true" data-e2e="produtos-carregando">
      {Array.from({ length: n }, (_, i) => <Cartao key={i} />)}
    </div>
  );
}
